import styled from 'styled-components';
import { Radio } from '@landlord-tech/ui-kit-opp/dist/components/Radio';

const SRadio = styled(Radio)`
  &&& {
  }
`;

export default SRadio;
